import * as yup from "yup";
import {INDUSTRIES, Roles, languages, Countries, Nationalities, wtList, LanguageLevels, EducationLevelList, DegreeFields} from "../../../../utilities/constants";

export const filterFormSchema = yup.object().shape({
    role: yup.string("The role is not valid."),
    email: yup.string("The email is not valid."),
    isAccountVerified: yup.bool("The account verification is not valid.").nullable(),
    workExperinceWT: yup.string("The W&T experience is not valid."),
    "profile.degreeField": yup.string("The degree field is not valid."),
});

export const filterFormFields = (promoters) => [
    {
        stepNo: 1,
        title: "Personal Information",
        fields: [
            {
                name: "profile.firstName",
                fieldId: "firstName",
                label: "Name",
                placeholder: "Petar",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "profile.lastName",
                fieldId: "lastName",
                label: "Surname",
                placeholder: "Petrov",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "email",
                fieldId: "email",
                label: "E-mail",
                placeholder: "petar@gmail.com",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "profile.nationality",
                fieldId: "nationality",
                label: "Citizenship",
                placeholder: "Macedonian",
                type: "select",
                values: [
                    { label: "Select a citizenship", value: "", disabled: true },
                    ...Nationalities.map((i) => ({ label: i, value: i })),
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "profile.address.country",
                fieldId: "country",
                label: "Country",
                placeholder: "Macedonia",
                type: "select",
                values: [
                    { label: "Select a country", value: "", disabled: true },
                    ...Countries.map((i) => ({ label: i, value: i })),
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "profile.address.city",
                fieldId: "city",
                label: "City",
                placeholder: "Skopje",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "profile.languages",
                fieldId: "languages",
                label: "Language",
                placeholder: "English",
                type: "select",
                isMulti: true,
                values: [
                    {label: "Select a language", value: ""},
                    ...languages
                        .filter(lang => lang.code && lang.name)
                        .map(lang => ({label: lang.name, value: lang.name}))
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "languageLevel",
                searchableFieldName: "profile.languages",
                fieldId: "languageLevel",
                label: "Language Level",
                placeholder: "B2",
                type: "select",
                values: [
                    {label: "Select a level", value: ""},
                    ...LanguageLevels.map(level => ({label: level, value: level}))
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
        ],
    },
    {
        stepNo: 2,
        title: "Work Experience",
        fields: [
            {
                name: "profile.workExperience",
                fieldId: "workExperience",
                label: "Work Experience",
                placeholder: "Manager",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "industry",
                searchableFieldName: "profile.workExperience",
                fieldId: "industry",
                label: "Industry",
                placeholder: "Economics",
                type: "select",
                values: [{label: "Select an industry", value: ""}, ...INDUSTRIES.asList()],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "workExperinceWT",
                searchableFieldName: "profile.workExperience",
                fieldId: "workExperinceWT",
                label: "W&T Experience",
                type: "select",
                values: [
                    {label: "Select W&T experience", value: ""},
                    ...wtList.map((i) => ({label: i, value: i}))
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
        ],
    },
    {
        stepNo: 3,
        title: "Education",
        fields: [
            {
                name: "profile.education",
                fieldId: "education",
                label: "Education",
                placeholder: "Faculty of Economics",
                type: "input-text",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "degree",
                searchableFieldName: "profile.education",
                fieldId: "degree",
                label: "Degree Field",
                type: "select",
                values: [
                    {label: "Select a field", value: ""},
                    ...DegreeFields.map(field => ({label: field, value: field}))
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "educationLevel",
                searchableFieldName: "profile.education",
                fieldId: "educationLevel",
                label: "Education Level",
                type: "select",
                values: [
                    {label: "Select a level", value: ""},
                    ...EducationLevelList.map(level => ({label: level, value: level}))
                ],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
        ],
    },
    {
        stepNo: 4,
        title: "Other Information",
        fields: [
            {
                name: "role",
                fieldId: "role",
                label: "Role",
                type: "select",
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                values: [{label: "Select a role", value: ""}, ...Roles.asList()],
                isRequired: false,
                size: 2,
            },
            {
                name: "referral",
                fieldId: "referral",
                label: "Referral",
                type: "select",
                values: [{value: "", label: "Select a promoter"}, ...promoters.map((i) => ({
                    value: i.email,
                    label: i.email
                }))],
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 3,
            },
            {
                name: "isAccountVerified",
                fieldId: "isAccountVerified",
                label: "Account Verified",
                type: "checkbox",
                value: true,
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "isEmailVerified",
                fieldId: "isEmailVerified",
                label: "Email Verified",
                type: "checkbox",
                value: true,
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
            {
                name: "jobApplicationsCount",
                fieldId: "jobApplicationsCount",
                label: "Applied to jobs?",
                type: "checkbox",
                value: true,
                style: {
                    padding: "0 10px",
                    size: "small",
                },
                isRequired: false,
                size: 2,
            },
        ],
    },
];
